import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  selector: '[bottomPanelHost]'
})
export class BottomPanelDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}